import { format } from "date-fns";
import { useTranslation } from "react-i18next";

export enum HeadingType {
  EVALUATION_REPORT = "evaluation report",
  IMPROVEMENT_PROPOSAL = "improvement proposal",
}

interface HeadingProps {
  type: HeadingType;
  companyCode: string;
  updatedAt: Date;
}

function ResultHeading({ type, companyCode, updatedAt }: HeadingProps) {
  const { t } = useTranslation();
  const updatedDate = format(updatedAt, t("date-format"));

  const generateDescription = (type: HeadingType) => {
    switch (type) {
      case HeadingType.EVALUATION_REPORT:
        return t("evaluation-results");
      case HeadingType.IMPROVEMENT_PROPOSAL:
        return t("improvement-proposal");
    }
  };

  return (
    <div className="pdf-component flex flex-col justify-between gap-4 border-b pb-5 lg:flex-row">
      <div className="flex flex-col gap-2">
        <div className="text-lg font-medium">
          {t("foreigner-employment-management-system-assessment")}
        </div>
        <div className="text-2xl font-bold">{generateDescription(type)}</div>
        <div className="flex gap-5">
          <span>
            {t("implementation-period")}: {updatedDate}
          </span>
          <span>
            {t("company-code")}: {companyCode}
          </span>
          <span>
            {t("report-date")}: {updatedDate}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ResultHeading;
